/** Normalized `account_type` from Redux `ProfileState.data.data`. */
export function getProfileAccountType(profileState: { data?: { data?: { account_type?: string } } } | null | undefined): string {
  return String(profileState?.data?.data?.account_type ?? "").toLowerCase();
}

export function isProfileBusinessAccount(profileState: { data?: { data?: { account_type?: string } } } | null | undefined): boolean {
  return getProfileAccountType(profileState) === "business";
}

export function isProfileIndividualAccount(profileState: { data?: { data?: { account_type?: string } } } | null | undefined): boolean {
  return getProfileAccountType(profileState) === "individual";
}
